import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-5e04a54e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "top-container" }
const _hoisted_3 = {
  key: 0,
  class: "logo",
  src: _imports_0
}
const _hoisted_4 = {
  key: 1,
  class: "title"
}
const _hoisted_5 = { class: "instruction" }
const _hoisted_6 = { class: "model-text" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "model-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f44336"} }, "您的手机型号可能无法完美接收云雀消息推送，建议您使用微信值班。 可在电脑端登录云雀工作台后，在 设置->手机值班 中进行绑定操作。", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "alert-text"
}
const _hoisted_12 = {
  key: 1,
  class: "alert-text"
}
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "actions" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("下一步")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.openType !== 'manual')
        ? (_openBlock(), _createElementBlock("img", _hoisted_3))
        : _createCommentVNode("", true),
      (_ctx.openType !== 'manual')
        ? (_openBlock(), _createElementBlock("h2", _hoisted_4, "欢迎使用云雀客服平台"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _createTextVNode(" 型号: " + _toDisplayString(_ctx.device) + " " + _toDisplayString(_ctx.hostType) + " " + _toDisplayString(_ctx.os) + " ", 1),
          (_ctx.hostType !== _ctx.HostTypes.iOS)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.mobile_type) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("p", _hoisted_8, _hoisted_10, 512), [
          [_vShow, _ctx.showPreferWechat]
        ]),
        (_ctx.isFirstRerender)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, " 请按以下步骤设置推送通知: "))
          : _createCommentVNode("", true),
        (!_ctx.isFirstRerender)
          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 没有打开推送通知，请按以下步骤设置: "))
          : _createCommentVNode("", true),
        _createElementVNode("p", {
          innerHTML: _ctx.instructionText,
          class: "instruction-text"
        }, null, 8, _hoisted_13)
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_van_button, {
        type: "primary",
        onClick: _ctx.goSettings
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_van_button, { onClick: _ctx.next }, {
        default: _withCtx(() => [
          _hoisted_16
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}